import { createSlice } from '@reduxjs/toolkit';

interface MarketplaceCartState {
  marketplaceCartQuantity: number;
}

const initialState = {
  marketplaceCartQuantity: 0,
} as MarketplaceCartState;

export const marketplaceCartSlice = createSlice({
  name: 'marketplaceCart',
  initialState,
  reducers: {
    setMarketplaceCartQuantity: (state, action) => {
      state.marketplaceCartQuantity = action.payload;
    },
  },
});

export const { setMarketplaceCartQuantity } = marketplaceCartSlice.actions;
export default marketplaceCartSlice.reducer;
